
import Vue from "vue";
import { getSignupReview, SignupReview, updateHygReviewed } from "@/api";
import { signupReviewEvidence } from "@/helpers/signupReviewEvidence";

const LABELS: Record<string, string> = {
  signup_ip_reuse: "Several recent signups from the same network",
  voip_phone: "Internet phone number",
  cdho_reuse: "College number shared under a different surname",
  cdho_conflict_attempt: "Repeated college-number conflicts during signup",
  address_match: "Street address shared with a recent profile",
  signup_ip_match: "Signup network shared with a recent profile"
};

export default Vue.extend({
  name: "SignupReviewDialog",
  data() {
    return { visible: false, loading: false, saving: false, error: "", approveAnyway: false,
      reason: "", talent: null as { id: number; firstName: string; lastName: string } | null,
      review: null as SignupReview | null, requestId: 0 };
  },
  computed: {
    hasWarnings(): boolean { return !!this.review && (this.review.signals.length > 0 || this.review.duplicates.length > 0); },
    canApprove(): boolean {
      return !!this.review && !this.loading && !this.saving && !this.error
        && (!this.review.requiresOverride || (this.approveAnyway && this.reason.trim().length >= 10));
    }
  },
  methods: {
    evidence: signupReviewEvidence,
    signalLabel(type: string): string { return LABELS[type] || "Account review warning"; },
    async open(talent: { id: number; firstName: string; lastName: string }) {
      this.talent = { ...talent }; this.visible = true;
      await this.load();
    },
    async load() {
      if (!this.talent) return;
      const requestId = ++this.requestId;
      this.loading = true; this.review = null; this.error = "";
      this.approveAnyway = false; this.reason = "";
      try {
        const review = await getSignupReview(this.talent.id);
        if (requestId === this.requestId) this.review = review;
      } catch (e) {
        if (requestId === this.requestId) this.error = e instanceof Error ? e.message : "Could not load account warnings.";
      } finally { if (requestId === this.requestId) this.loading = false; }
    },
    async approve() {
      if (!this.canApprove || !this.talent || !this.review) return;
      this.saving = true;
      try {
        await updateHygReviewed({ id: this.talent.id, data: { reviewed: 1 },
          ...(this.review.requiresOverride ? { riskOverride: { approveAnyway: true, reason: this.reason.trim(), version: this.review.version } } : {}) });
        const id = this.talent.id;
        this.visible = false; this.$emit("approved", id);
      } catch (e) {
        const message = e instanceof Error ? e.message : "Could not approve this account.";
        await this.load();
        this.error = message;
      } finally { this.saving = false; }
    }
  }
});
